import Cryptr from 'cryptr'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import AuthService from '../../../business-api/AuthService'

import ClienteService from '../../../business-api/ClienteService'

import IntegracaoService from '../../../business-api/IntegracaoService'

import {
    dataAtual,
    somaDiasData,
} from '../../../business-components/Date/Date'

import {
    mensagemErroErro
} from '../../../business-components/Toastr/Toastr'

import {
    obtemUrlSignin
} from '../../../business-components/Url/Url'



export const processaValoresDefaultIniciaisGerarLinkCliente = ( values ) => {

   if (!values.dataHoraValidadeLink) {

        values.dataHoraValidadeLink = somaDiasData(dataAtual(), HARDCODE.validadeLinkCostumerDiasDefault)
    }
}



export const dataHoraValidadeLinkMaxima = (values) => {

    return somaDiasData(dataAtual(),
        values.disponibilizarAcompanhamento
            ?
                HARDCODE.validadeLinkCostumerDiasMaximoComAcompanhamento
            :
                values.disponibilizarRelatorioSimulacaoFinanceira || values.disponibilizarRelatorioEstudo
                    ?
                        HARDCODE.validadeLinkCostumerDiasMaximoRelatorios
                    :
                        HARDCODE.validadeLinkCostumerDiasMaximo
        )
}

export const dataHoraValidadeLinkValida = (values) => {

    return values.dataHoraValidadeLink < dataHoraValidadeLinkMaxima(values)
}



export const gerarLinkCliente = async ( variaveisGlobais, values ) => {

    const integracaoService = new IntegracaoService()

    const urlSignin = obtemUrlSignin()

    try {

        const response = await integracaoService.obterTokenIntegracaoInterno(variaveisGlobais,
            {
                idUsuarioLogado: AuthService.obterUsuarioLogado(variaveisGlobais),
                idUsuarioClienteSelecionado: ClienteService.obterUsuarioClienteSelecionado(variaveisGlobais),
                jsonAcessoCliente: JSON.stringify({
                    idCliente: values.id,
                    disponibilizarInclusaoRevisaoDadosBasicos: values.disponibilizarInclusaoRevisaoDadosBasicos,
                    disponibilizarInclusaoRevisaoRiscos: values.disponibilizarInclusaoRevisaoRiscos,
                    disponibilizarRelatorioSimulacaoFinanceira: values.disponibilizarRelatorioSimulacaoFinanceira,
                    exibirCapacidadePoupancaRelatorio: values.exibirCapacidadePoupancaRelatorio,
                    exibirAportesRetiradasPlanejadosRelatorio: values.exibirAportesRetiradasPlanejadosRelatorio,
                    naoExibirGraficoDiagnosticoAposentadoriaIndependenciaFinanceira:
                        values.naoExibirGraficoDiagnosticoAposentadoriaIndependenciaFinanceira,
                    naoExibirEvolucaoReservaFinanceira: values.naoExibirEvolucaoReservaFinanceira,
                    exibirProtecaoSugeridaRelatorio: values.exibirProtecaoSugeridaRelatorio,
                    exibirSucessaoVitaliciaRelatorio: values.exibirSucessaoVitaliciaRelatorio,
                    exibirComparacaoCenariosRelatorio: values.exibirComparacaoCenariosRelatorio,
                    exibirComparacaoCenariosRelatorioSemTabelaGrafico: values.exibirComparacaoCenariosRelatorioSemTabelaGrafico,
                    exibirComparacaoEstudosRelatorio: values.exibirComparacaoEstudosRelatorio,
                    exibirConsideracoesFinaisRelatorio: values.exibirConsideracoesFinaisRelatorio,
                    disponibilizarRelatorioEstudo: values.disponibilizarRelatorioEstudo,
                    formulario: values.formulario,
                    cenarioAtual: values.cenarioAtual,
                    descricaoCenario: values.descricaoCenario,
                    template: values.template,
                    disposicaoRelatorio: values.disposicaoRelatorio,
                    reportImprimir: values.reportImprimir,
                    reportNaoImprimir: values.reportNaoImprimir,
                    disponibilizarAcompanhamento: values.disponibilizarAcompanhamento
                }),
                dataHoraValidadeToken: values.dataHoraValidadeLink,
            }
        )

        const cryptr = new Cryptr(HARDCODE.costumer)

        const encryptedString =
            cryptr.encrypt(
                '{' +
                '"email": "' + response.data.emailUsuarioLogado + '", ' +
                '"tokenIntegracao": "' + response.data.token +
                '"}'
            )

        return urlSignin + HARDCODE.urlSignin + HARDCODE.urlCostumer + encryptedString

    } catch (erro) {

        mensagemErroErro(erro)
        
        return false
    }
}